// extracted by mini-css-extract-plugin
export default {"wrapper":"form-group_wrapper--CgAP1","title":"form-group_title--nMA0S","description":"form-group_description--wXapx"};